export const CHANGE_UNSAVED_CHANGES = 'CHANGE_UNSAVED_CHANGES';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SET_ONBOARDING_MODE = 'SET_ONBOARDING_MODE';
export const SET_GMAIL_MODE = 'SET_GMAIL_MODE';
export const SET_USER_SESSION = 'SET_USER_SESSION';
export const SET_WELCOME_DONE = 'SET_WELCOME_DONE';
export const SET_HIDDEN_LOADING_BAR = 'SET_HIDDEN_LOADING_BAR';
export const SET_INCOMING_URL = 'SET_INCOMING_URL';
export const SET_USER_PROPERTY = 'SET_USER_PROPERTY';
export const SET_USER_GROUP_PROPERTY = 'SET_USER_GROUP_PROPERTY';
export const ACTIVATE_LOADER = 'ACTIVATE_LOADER';
export const DE_ACTIVATE_LOADER = 'DE_ACTIVATE_LOADER';
